/* src/app/warehousing/partials/product-class-form/product-class-form.component.scss */
/*# sourceMappingURL=product-class-form.component.css.map */
